import * as React from "react";
import { Theme, styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import MuiAppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import { useEffect } from "react";
import { Collapse, Toolbar } from "@mui/material";
import TextContainer from "../Texts/TextContainer";
import MenuIcon from "@mui/icons-material/Menu";
import { AccountCircle } from "@mui/icons-material";
import MoreIcon from "@mui/icons-material/MoreVert";
import AppbarMenuItems from "./menuItems";
import { AppbarTopic } from "../Texts/styles";
import { useSelector } from "react-redux";
import { RootState } from "../../app/index";

const ProfileCard = styled(Box)({
  width: "100%",
  height: "25vh",
  borderRadius: "12px",
  minHeight: "20vh",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
});
type mainprops = {
  open: boolean;
  theme: Theme;
};
const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }: mainprops) => ({
    flexGrow: 1,
    padding: 0,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    height: "90vh",
    display: "flex",
    flexDirection: "row",
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  })
);
type appBarProps = {
  open: boolean;
  theme: Theme;
};
const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }: appBarProps) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
  height: "10vh",
  backgroundImage: "unset",
}));
type props = {
  children: React.ReactNode;
  menuItems?: React.ReactNode;
};

export default function DrawerMenu({
  children,
  menuItems = <AppbarMenuItems />,
}: props) {
  const [open, setOpen] = React.useState<boolean>(true);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] =
    React.useState<null | HTMLElement>(null);
  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMobileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };
  const [screenWidth, setScreenWidth] = React.useState(window.innerWidth);
  const theme = useTheme();
  const updateScreenWidth = () => {
    setScreenWidth(window.innerWidth);
  };
  useEffect(() => {
    window.addEventListener("resize", updateScreenWidth);
    return () => {
      window.removeEventListener("resize", updateScreenWidth);
    };
  }, []);
  useEffect(() => {
    if (screenWidth < 960) {
      setOpen(false);
    }
  }, [screenWidth]);
  const menuId = "primary-search-account-menu";

  const user = useSelector((state: RootState) => state.user);

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <CssBaseline />
      <AppBar
        theme={theme}
        position="relative"
        open={open}
        sx={{ bgcolor: "primary.main", justifyContent: "center" }}
      >
        <Toolbar style={{ justifyContent: "space-between", padding: "0 15px" }}>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="open drawer"
            sx={{ mr: 2 }}
            onClick={() => setOpen(!open)}
          >
            <MenuIcon sx={{ color: "divider" }} />
          </IconButton>
          <TextContainer
            variant="h6"
            noWrap
            padding="0 1rem"
            {...AppbarTopic}
            sx={{ display: { xs: "none", sm: "block" } }}
          >
            پنل مدیریت
          </TextContainer>
          <Box sx={{ flexGrow: 1 }} />
          <Box sx={{ display: { xs: "none", md: "flex" } }}>
            <IconButton
              size="large"
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <AccountCircle sx={{ color: "divider" }} />
            </IconButton>
          </Box>
          <Box sx={{ display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="show more"
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MoreIcon sx={{ color: "divider" }} />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      <Main open={open} theme={theme}>
        <Drawer
          sx={{
            width: "22%",
            transition: "all .2s",
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              bgcolor: "primary.light",
              height: "90vh",
              overflow: "hidden",
              transition: "all .2s",
              // marginTop: "10vh",
              border: "none",
              position: "sticky",
              color: "divider",
              width: "100%",
              zIndex: 1,
              boxSizing: "border-box",
            },
            display: open ? "blobk" : "none",
          }}
          variant="permanent"
          anchor="right"
          open={open}
        >
          <Collapse
            sx={{
              bgcolor: "primary.light",
              height: "100%",
              ".MuiCollapse-wrapper": {
                width: "100%",
                bgcolor: "primary.light",
              },
              ".css-14vyde3-MuiCollapse-wrapperInner": {
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                bgcolor: "primary.light",
                height: "100%",
                width: "100%",
              },
            }}
            orientation="horizontal"
            in={open}
          >
            <Box
              width="100%"
              bgcolor="primary.main"
              height="93vh"
              padding=".5rem"
            >
              <ProfileCard bgcolor="primary.light">
                <img
                  alt="profile"
                  width="100%"
                  height="100%"
                  src={require("../../assets/images/profile.png")}
                  style={{
                    borderRadius: "50%",
                    background: "rgb(33,33,33)",
                    maxWidth: "13vh",
                    maxHeight: "13vh",
                  }}
                />
                <TextContainer
                  color="secondary.main"
                  width="100%"
                  justifyContent="center"
                  fontFamily="'YekanBold !important'"
                  fontSize="1rem"
                >
                  {user.firstName} {user.lastName}
                </TextContainer>
                <TextContainer
                  color="divider"
                  width="100%"
                  justifyContent="center"
                  fontSize=".8rem"
                >
                  {user.phone}
                </TextContainer>
              </ProfileCard>
              {menuItems}
            </Box>
          </Collapse>
        </Drawer>
        {children}
      </Main>
    </Box>
  );
}
